export const calculateAgeFromDates = (birth: Date, referenceDate: Date = new Date()): number => {
  let age = referenceDate.getFullYear() - birth.getFullYear();

  if (
    referenceDate.getMonth() < birth.getMonth() ||
    (referenceDate.getMonth() === birth.getMonth() && referenceDate.getDate() < birth.getDate())
  ) {
    age -= 1;
  }

  return age;
};
